import React, { useMemo, useCallback, useEffect, useState } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import { baseSymbol, formatMoneyMajor } from '../../core/currency';

const Range = Slider.Range;


const PriceRange = ({ min, max, onChange }) => {
    const safeMin = typeof min === 'number' ? min : 0;
    const safeMax = typeof max === 'number' ? max : (safeMin + 1000000);
    
    const validMax = Math.max(safeMax, safeMin + 100);
    
    const sliderConfig = useMemo(() => {
        const sliderMin = Math.max(0, Math.round(safeMin / 100));
        const sliderMax = Math.max(sliderMin + 1, Math.min(50000, Math.round(validMax / 100)));
        
        const range = sliderMax - sliderMin;
        const step = range > 10000 ? 500 : (range > 5000 ? 250 : (range > 1000 ? 100 : (range > 100 ? 10 : 1)));
        
        return { sliderMin, sliderMax, step };
    }, [safeMin, validMax]);

    const formatPrice = useCallback((value) => {
        try {
            return formatMoneyMajor(value, { decimals: 0 });
        } catch (error) {
            return `${baseSymbol()}${value}`;
        }
    }, []);

    const handleRangeChange = useCallback((values) => {
        if (onChange && Array.isArray(values) && values.length === 2) {
            try {
                clearTimeout(window._priceRangeTimeout);
                window._priceRangeTimeout = setTimeout(() => {
                    onChange(values);
                }, 150);
            } catch (error) {
                console.error('Range change error:', error);
            }
        }
    }, [onChange]);

    useEffect(() => {
        return () => {
            if (window._priceRangeTimeout) {
                clearTimeout(window._priceRangeTimeout);
            }
        };
    }, []);

    const { sliderMin, sliderMax, step } = sliderConfig;
    
    const [currentValues, setCurrentValues] = useState([sliderMin, sliderMax]);
    
    useEffect(() => {
        setCurrentValues([sliderMin, sliderMax]);
    }, [sliderMin, sliderMax]);
    
    const handleSliderChange = useCallback((values) => {
        if (Array.isArray(values) && values.length === 2) {
            setCurrentValues(prev => {
                if (prev[0] !== values[0] || prev[1] !== values[1]) {
                    return values;
                }
                return prev;
            });
        }
    }, []);
    
    if (!isFinite(sliderMin) || !isFinite(sliderMax) || sliderMin >= sliderMax) {
        console.warn('Invalid price range values:', { min: safeMin, max: validMax });
        return (
            <div className="range-container">
                <p className="text-muted">Price range unavailable</p>
            </div>
        );
    }

    return (
        <div className="range-container">
            <div className="price-range-labels mb-2" style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                width: '100%',
                fontSize: '14px',
                fontWeight: '500'
            }}>
                <span style={{ color: '#666' }}>{formatPrice(currentValues[0])}</span>
                <span style={{ color: '#666' }}>{formatPrice(currentValues[1])}</span>
            </div>
            <Range
                min={sliderMin}
                max={sliderMax}
                step={step}
                onChange={handleSliderChange}
                onAfterChange={handleRangeChange}
                value={currentValues}
                allowCross={false}
            />
        </div>
    )
}

export default PriceRange